export default __webpack_public_path__ + "static/media/beag.5b42c807.mp3";